import { render, staticRenderFns } from "./RecargoDelete.vue?vue&type=template&id=fe88109e&"
import script from "./RecargoDelete.vue?vue&type=script&lang=js&"
export * from "./RecargoDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports